import { DATE_FORMAT } from 'framework/utils';
import { BillingScheduleItemResult } from '../billingTypes';
import { formatChangeRequestAlias } from '../billingUtils';
import moment from 'moment';
import { BillingTableColumn } from './ApproveBillingContent.types';

const formatAmount = (amount: number | null | undefined, currency: string | null | undefined) => {
  if (amount == null) return '-';
  return `${amount.toLocaleString()} ${currency || ''}`;
};

const getItemName = (item: BillingScheduleItemResult): string => {
  if (item.milestoneName) return item.milestoneName;
  if ('changeRequestAlias' in item && item.changeRequestAlias)
    return formatChangeRequestAlias(item.changeRequestAlias as string);
  if (item.periodMonth)
    return `Period ${item.position} - ${moment(item.periodMonth, DATE_FORMAT.API_ONLY_MONTH).format(DATE_FORMAT.MONTH)}`;
  return item.alias || `Item ${item.position}`;
};

export const sortByPosition = (a: BillingScheduleItemResult, b: BillingScheduleItemResult): number =>
  Number(a.position) - Number(b.position);

const formatHours = (value: number | null | undefined): string => (value == null ? '-' : String(value));

export const getApproveBillingColumns = (isPrepaid: boolean, isPlannedHours: boolean): BillingTableColumn[] => {
  if (isPrepaid && isPlannedHours) {
    return [
      {
        id: 'item',
        label: 'Item',
        size: 2.5,
        renderCell: item => getItemName(item),
      },
      {
        id: 'plannedHours',
        label: 'Planned hours',
        size: 2,
        renderCell: item => formatHours(item.plannedRegularHours),
      },
      {
        id: 'plannedOvertimeHours',
        label: 'Planned overtime hours',
        size: 2.5,
        renderCell: item => formatHours(item.plannedOvertimeHours),
      },
      {
        id: 'previousPeriodAdjustmentHours',
        label: 'Previous period adjustment hours',
        size: 3,
        renderCell: item => formatHours(item.previousPeriodAdjustmentHours),
      },
      {
        id: 'amount',
        label: 'Total amount',
        size: 2,
        renderCell: item => formatAmount(item.amount, item.currency),
        renderTotal: (totalAmount, currency) => formatAmount(totalAmount, currency),
      },
    ];
  }

  return [
    {
      id: 'item',
      label: 'Item',
      size: 8,
      renderCell: item => getItemName(item),
    },
    {
      id: 'amount',
      label: 'Amount',
      size: 4,
      renderCell: item => formatAmount(item.amount, item.currency),
      renderTotal: (totalAmount, currency) => formatAmount(totalAmount, currency),
    },
  ];
};
